import { Pipe, PipeTransform } from '@angular/core';

import { CodeAndLabel } from '@models/code-and-label';

@Pipe({
  name: 'codeAndLabel',
  standalone: true
})
export class CodeAndLabelPipe<T> implements PipeTransform {
  transform(value: T, values: CodeAndLabel<T>[], onlyLabel: boolean = true): string {
    const foundedCodeAndLabel = values?.find((codeAndLabel: CodeAndLabel<T>) => codeAndLabel.code === value);

    if (!foundedCodeAndLabel) {
      return '';
    }

    if (onlyLabel) {
      return foundedCodeAndLabel.label ?? '';
    }

    return foundedCodeAndLabel.code && foundedCodeAndLabel.label
      ? `${foundedCodeAndLabel.code} - ${foundedCodeAndLabel.label}`
      : '';
  }
}
